import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { asyncActions } from "../../../actions/general";
import { acceptMerchantInvite } from "../../../actions/merchants";
import { fetchStatus } from "../../../actions/post_approval_plaid";
import { loading } from "../../../actions/sessions";
import useRouteStatus from "../../../hooks/useRouteStatus";
import useSession from "../../../hooks/useSession";
import useSessionEntity from "../../../hooks/useSessionEntity";
import { emitEvent } from "../../../lib/utils/modal";
import PostApprovalPlaidApproved from "../post_approval/PostApprovalPlaidApproved";
import Default from "./approved/Default";
import NextSteps from "./approved/NextSteps";
import Recharge from "./approved/Recharge";

export default function Approved({ location }) {
  const dispatch = useDispatch();
  const [connectedMerchant, setConnectedMerchant] = useState();
  const [session, sessionActions] = useSession();
  const company = useSessionEntity("company");
  const user = useSessionEntity("user");
  const cart = useSessionEntity("shopping_cart");
  const merchant = useSessionEntity("merchant");
  const isRecharge =
    session.hasCustomFlag("recharge") || session.hasCustomFlag("instore");

  const publicKey = useSelector((state) => state.sessions.get("public_key"));
  const postApproval = useSelector((state) => state.post_approval_plaid);
  const attempt =
    postApproval?.get("application_id") === session.application_id
      ? postApproval.get("attempt")
      : null;
  const hasPostApprovalResult =
    session.session_type === "apply_now" && attempt?.isTerminal;

  // Read back an existing result on refresh. GET never offers a new attempt.
  useEffect(() => {
    if (
      session.session_type !== "apply_now" ||
      !session.application_id ||
      isRecharge
    )
      return;
    dispatch(
      fetchStatus(session.application_id, { sessionId: session.id, publicKey })
    ).catch(() => undefined);
  }, [
    dispatch,
    session.id,
    session.application_id,
    session.session_type,
    publicKey,
    isRecharge,
  ]);

  useRouteStatus(location);

  useEffect(() => {
    emitEvent(
      user,
      {
        path: location.pathname,
        credit_line: company.credit_line,
      },
      cart
    );

    if (session.invite_slug) {
      dispatch(loading(true));
      dispatch(
        asyncActions(acceptMerchantInvite(session.invite_slug, company.id))
      )
        .then((inviteMerchant) => setConnectedMerchant(inviteMerchant))
        .catch((e) => console.log(e))
        .finally(() => dispatch(loading(false)));
    }

    sessionActions.finish();
  }, []);

  return (
    <div role="main" className="mx-6 sm:mx-auto">
      {isRecharge && <Recharge merchant={merchant} session={session} />}
      {!isRecharge && merchant?.supports_vcinstore && (
        <NextSteps company={company} />
      )}
      {!isRecharge &&
        !merchant?.supports_vcinstore &&
        (hasPostApprovalResult ? (
          <PostApprovalPlaidApproved
            attempt={attempt}
            company={company}
            merchant={merchant}
            connectedMerchant={connectedMerchant}
          />
        ) : (
          <Default merchant={merchant} connectedMerchant={connectedMerchant} />
        ))}
    </div>
  );
}
